import { Suspense, useEffect } from 'react';
import { Flex, Box } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { Spinner } from 'components/elements/Spinner';
import CustomMap from 'components/widgets/LocationMap/CustomMap';
import { useMapState } from 'state/map';
import { DEFAULT_MAP_ZOOM } from 'utils/constants';
import type { CustomMapProps } from 'components/widgets/LocationMap/CustomMap';

const errorContainer = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: Colors.ArmyGreen200,
};

type SxProps = {
  sx?: object;
};

export const LocationMap = (props: CustomMapProps, { sx }: SxProps) => {
  const { mapRef } = useMapState();
  const { center } = props;

  useEffect(() => {
    // eslint-disable-next-line react/destructuring-assignment
    mapRef?.setZoom(props.mapProps?.zoom ?? DEFAULT_MAP_ZOOM);

    return () => {
      // Reset the global mapRef zoom when unmounting
      mapRef?.setZoom(DEFAULT_MAP_ZOOM);
    };
  }, []);

  if (!center?.lat || !center?.lng) {
    return (
      <Flex
        borderRadius={4}
        overflow="hidden"
        sx={{
          '.gmnoprint': {
            display: 'none',
          },
          height: '100%',
          width: '100%',
          ...sx,
        }}
      >
        <Box sx={errorContainer}>
          <Text.Body color={Colors.TextQuiet}>Unable to locate on map</Text.Body>
        </Box>
      </Flex>
    );
  }

  return (
    <Flex
      borderRadius={4}
      overflow="hidden"
      sx={{
        '.gmnoprint': {
          display: 'none',
        },
        height: '100%',
        width: '100%',
        ...sx,
      }}
    >
      <Suspense fallback={<Spinner />}>
        <CustomMap showLoadingSpinner={false} {...props} />
      </Suspense>
    </Flex>
  );
};
